import React, { useEffect, useState } from "react";
import { Button, Spinner } from "reactstrap";
import SyncModal from "../components/john-deere/SyncModal";
import Moment from "react-moment";
import JohnDeereConnect from "../components/john-deere/login/connect";
import { withAuthenticationRequired } from "@auth0/auth0-react";

const JohnDeere = () => {
  const [apiStatus, setApiStatus] = useState<any | undefined>(undefined);
  const [isSyncing, setSyncing] = useState(false);
  const [syncItems, setSyncItems] = useState(0);
  const [currentSyncItems, setCurrentSyncItems] = useState(0);
  const [pendingSyncItems, setPendingSyncItems] = useState(0);
  const [syncCanceled, setSyncCanceled] = useState(false);

  const fetchSyncItemsStat = async () => {
    const endpoint = `${process.env.REACT_APP_JD_API_URL}/sync/stat`;
    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    switch (response.status) {
      case 200:
        const data = await response.json();
        setSyncItems(data.items_pending_to_sync);
        console.log(data);
        return data.items_pending_to_sync;
      default:
        console.log("Error al sincronizar datos");
        break;
    }
  }

  const fetchSyncItems = async (items?: number) => {
    const endpoint = `${process.env.REACT_APP_JD_API_URL}/sync`;
    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log(response.status);
    switch (response.status) {
      case 200:
        const data = await response.json();
        console.log(data);
        setCurrentSyncItems((items === undefined ? syncItems : items) - data.items_pending_to_sync);
        setPendingSyncItems(data.items_pending_to_sync);
        break;
      default:
        console.log("Error al sincronizar datos");
        break;
    }
  };

  const cancelSync = () => {
    setSyncCanceled(true);
  };

  const stopSyncing = () => {
    setSyncing(false);
    setSyncItems(0);
    setSyncCanceled(false);
  };

  const refreshApiStatus = async () => {
    console.log("JD URL:", process.env.REACT_APP_JD_API_URL);
    const endpoint = `${process.env.REACT_APP_JD_API_URL}/status`;
    const response = await fetch(endpoint, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    switch (response.status) {
      case 200:
        const apiStatus = await response.json();
        console.log("API Status:", apiStatus);
        setApiStatus(apiStatus);
        break;
      case 404:
        console.log("response:", response);
        setApiStatus({});
        break;
      default:
        setApiStatus(undefined);
    };
  };

  const syncApiData = async () => {
    setSyncing(true);
    const items = await fetchSyncItemsStat();

    if (items === 0) setSyncing(false);
    console.log("status pending", pendingSyncItems);
    console.log("status current", currentSyncItems);
    console.log("status total", syncItems);
  };

  useEffect(() => {
    console.log("syncItems:", syncItems);
    if (syncItems > 0 && isSyncing && !syncCanceled) {
      fetchSyncItems();
      console.log("status pending", pendingSyncItems);
      console.log("status current", currentSyncItems);
      console.log("status total", syncItems);
      if (syncCanceled) {
        stopSyncing();
      }
    }
  }, [syncItems]);

  useEffect(() => {
    if (pendingSyncItems === 0) {
      stopSyncing();
    }
  }, [pendingSyncItems]);

  useEffect(() => {
    if (currentSyncItems === 0 && isSyncing) {
      stopSyncing();
      return;
    } else if (isSyncing) {
      fetchSyncItems();
      console.log("finished sync");
      console.log("status pending", pendingSyncItems);
      console.log("status current", currentSyncItems);
      console.log("status total", syncItems);
      if (syncCanceled) {
        stopSyncing();
      }
    }
  }, [currentSyncItems]);

  useEffect(() => {
    if (syncCanceled && currentSyncItems === 0 && pendingSyncItems === 0) {
      stopSyncing();
    }
  }, [syncCanceled]);

  useEffect(() => {
    refreshApiStatus();
  }, []);

  return (
    <div>
      <h1>John Deere</h1>
      <div>
        {(() => {
          if (apiStatus === undefined) {
            return <p>Verificando estado de la API...</p>;
          } else if (apiStatus.api_expiration_timestamp) {
            const expirationDate = new Date(apiStatus.api_expiration_timestamp * 1000);
            const isExpired = expirationDate < new Date();
            return (
              <>
                <p>Estado: {isExpired ? (<span className="expired">Expirada</span>) : (<span className="active">Activa</span>)}</p>
                <p>Ultima actualizacion: {apiStatus.api_last_sync ? new Date(apiStatus.api_last_sync).toDateString() : "Nunca"}</p>
                <p>
                  Fecha de expiración: <Moment fromNow>
                    {new Date(apiStatus.api_expiration_timestamp * 1000).toISOString()}
                  </Moment>
                </p>
                <h3>Organizaciones conectadas</h3>
                <ul>
                  {apiStatus.api_connected_organizations.map((org: any, idx: number) => {
                    return <li key={idx}>
                      <div>
                        <span>Nombre: {org.name}</span>
                        <br />
                        <span>Id: {org.organization_id}</span>
                      </div>
                    </li>;
                  })}
                </ul>
                <div>
                  {isExpired ? (
                    <JohnDeereConnect />
                  ) : (
                    <Button
                      className="btn btn-success btn-rounded btn-block"
                      disabled={isSyncing}
                      onClick={syncApiData}
                    >
                      {isSyncing ? (
                        <>
                          <Spinner size="sm">
                            Actualizando datos...
                          </Spinner>
                          <span>
                            {' '}Actualizando datos...
                          </span>
                        </>
                      ) : (
                        "Actualizar datos"
                      )}
                    </Button>
                  )}
                </div>
                <SyncModal
                  showModal={isSyncing}
                  maxItems={syncItems}
                  currentItems={currentSyncItems}
                  syncCanceled={syncCanceled}
                  toggleModal={() => { }}
                  onClickCancel={cancelSync}
                />
              </>
            );
          } else {
            return (
              <>
                <p>API no disponible</p>
                <JohnDeereConnect />
              </>
            );
          }
        })()}
      </div>
    </div>
  )
}

export default withAuthenticationRequired(JohnDeere);